import React, { useEffect } from 'react'

import { gsap } from 'gsap/gsap-core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { Icon } from '@iconify/react'
import bulmaIcon from '@iconify/icons-logos/bulma'
import reactIcon from '@iconify/icons-logos/react'
import gatsbyIcon from '@iconify/icons-logos/gatsby'
import bemIcon from '@iconify/icons-logos/bem'

import GsapIcon from '../assets/svg/gsap-omg.svg'
import StrapiIcon from '../assets/svg/strapi-omg.svg'
import useResponsive from '../hooks/useResponsive'

gsap.registerPlugin(ScrollTrigger);

export default () => {

  const { isWidescreen } = useResponsive()

  const stack = [
    {
      el: <Icon icon={gatsbyIcon} height={isWidescreen ? 120 : 100} />,
      alt: 'Gatsby',
      link: 'https://www.gatsbyjs.com/',
    },
    {
      el: <Icon icon={reactIcon} height={isWidescreen ? 120 : 100} />,
      alt: 'React',
      link: 'https://reactjs.org/',
    },
    {
      el: <StrapiIcon height={isWidescreen ? 120 : 100} />,
      alt: 'Strapi',
      link: 'https://strapi.io/',
    },
    {
      el: <Icon icon={bulmaIcon} height={isWidescreen ? 120 : 100} />,
      alt: 'Bulma',
      link: 'https://bulma.io/',
    },
    {
      el: <GsapIcon height={isWidescreen ? 120 : 100} />,
      alt: 'GSAP',
      link: 'https://greensock.com/gsap/',
      supClass: 'devstack__GSAP',
    },
    {
      el: <Icon icon={bemIcon} height={isWidescreen ? 120 : 100} />,
      alt: 'BEM',
      link: 'http://getbem.com/',
      supClass: 'devstack__BEM',
    },
  ]

  useEffect(() => {

    const glitchBorder = () => {
      gsap.killTweensOf('.devstack__borderBottom')
      gsap
        .timeline({
          delay: (Math.floor(Math.random() * 5) + 3),
          onComplete: glitchBorder,
        })
        .fromTo('.devstack__borderBottom',
          { y: 0, },
          { y: -15, duration: .01, })
        .fromTo('.devstack__borderBottom',
          { y: 0, },
          { y: 5, duration: .01, })
        .fromTo('.devstack__borderBottom',
          { y: 0, },
          { y: 10, duration: .01, })
        .to('.devstack__borderBottom',
          { y: 0, duration: .01, })
    }

    glitchBorder()

    gsap
    .timeline({
      scrollTrigger: {
        id: `devstack`,
        trigger: '.devstack',
        start: 'top bottom-=200',
        toggleActions: 'play none none none',
        markers: false,
      },
    })
    .fromTo('.devstack__title, .devstack__iconWrapper', {
      autoAlpha: 0,
      y: 100,
    }, {
      autoAlpha: 1,
      y: 0,
      stagger: .2,
    })
  }, [])

  return (
    <div className="devstack">
      <h2 className="title is-4 devstack__title">
        <div className="devstack__innerTitle">
          <div className="devstack__borderBottom"></div>
          <div className="devstack__titleText">Current Stack</div>
        </div>
      </h2>
      <div className="level devstack__iconList">
        {
          stack.map((item, index) => (
            <div className={"level-item devstack__iconWrapper " + (item.supClass || '') } key={'item-' + index}>
              <a target="_blank" rel="noreferrer" className="block devstack__link" href={item.link} title={item.alt}>
                {item.el}
              </a>
            </div>
          ))
        }
      </div>
    </div>
  )
}
